import React, { useEffect, useState, useCallback } from "react";

const Output = (props) => {
  const userRawText = props.userRawInput;
  const [emojifiedText, setEmojifiedText] = useState('');

  let chooseElement = (listOfOptions) => {
    if(listOfOptions !== undefined) {
      let size = listOfOptions.length;
      let index = Math.floor((Math.random() * size));
      return listOfOptions[index];
    }
    return '';
  };


  const emojifyText = useCallback(text => {
    const charDictionary = {
      'a' : [" 🔼  ", " 🖇  ", " 🅰️ "],
      'b' : [" 🅱️ "],
      'c' : [" ©️ ", " 🗜  "],
      'd' : [" ↩️  ", "  🌮  ", " 🇩  "],
      'e' : [" 📧  "],
      'f' : [" 🎏  "],
      'g' : [" 🇬  "],
      'h' : [" 🛏 ", " ♊ "],
      'i' : [" ℹ️ "],
      'j' : [" 🗾  ", " 🌶 "],
      'k' : [" 🎋 "],
      'l' : [" 👢  ", " 💪  "],
      'm' : [" 〽️ ", " Ⓜ "],
      'n' : [" ♑ "],
      'o' : [" ⭕  ", " 🍪 "],
      'p' : [" 🅿 "],
      'q' : [" ♌ ", " 🍳  "],
      'r' : [" 🇷  ", "  ®️  "],
      's' : [" ⚡ "],
      't' : [" 🌴  ", " ☂ "],
      'u' : [" ⛎  ", " 🐋  "],
      'v' : [" ♈  ", " ✔️  ", "   ✅  "],
      'w' : [" 〰️  "],
      'x' : [" ❌  ", " ✂️ "],
      'y' : [" ✌️ ", " 🌱  "],
      'z' : [" Ⓩ "],
      '?' : ["❓ "],
      '!' : ["❗ "],
      ' ' : ['__']
    };
    const newText = text.replace(/[a-z !?]/gi, (caracter) => chooseElement(charDictionary[caracter]));
    setEmojifiedText(newText);
  }, []);

  useEffect(() => {
    const lowerCaseUserRawText = userRawText.toLowerCase();
    emojifyText(lowerCaseUserRawText);
  },
  [userRawText, emojifyText]);

  return (
    <form type="text">
      <textarea
        placeholder={props.placeholder}
        readOnly={true}
        value={ emojifiedText }
        className='result'
      />
    </form> 
  );

};

export default Output;